/**
 * JS for ACF: Flexible Content > Layouts > Slider avec miniatures
 */

// thumbnails navigation
const galleryThumbs = new Swiper(".gallery-thumbs", {
  direction: "horizontal",
  slidesPerView: 3,
  spaceBetween: 10,
  mousewheel: {
    invert: false,
  },
  breakpoints: {
    540: {
      slidesPerView: 5,
    },
    720: {
      slidesPerView: 7,
    },
    890: {
      slidesPerView: 8,
    },
    1280: {
      slideToClickedSlide: true,
      spaceBetween: 14,
      direction: "vertical",
      slidesPerView: 6,
      slidesPerGroup: 2,
      grabCursor: true,
    },
  },
});

// main slider
const galleryTop = new Swiper(".gallery-top", {
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 5,
  autoHeight: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: galleryThumbs,
    autoScrollOffset: 2,
  },
  breakpoints: {
    1280: {
      autoHeight: false,
    }
  },
  on: {
    transitionStart: function(){
      const videos = document.querySelectorAll('video');
      Array.prototype.forEach.call(videos, function(video){
        video.pause();
      });
    },

    transitionEnd: function(){
      const activeIndex = this.activeIndex;
      const activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
      const activeVideo = activeSlide.getElementsByTagName('video');
      if( activeVideo.length > 0 ){
        const video = activeVideo[0];
        video.play();
      }
    },
  }
});
